import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArchiveStore from 'pages/Stores/ArchiveStore';
import { StoresContextProvider, useStoresContext } from 'pages/Stores/stores.context';
import UpdateStore from 'pages/Stores/UpdateStore';
import { BrandsContextProvider } from 'pages/Brands/brands.context';
import { UsersContextProvider } from 'context/users.context';
import Overview from 'components/Overview/Overview';
import { OverviewDetailInterface } from 'components/Overview/overview.types';

const StoreComponent = () => {
  const { storeId } = useParams();
  const { getStoreById, loading } = useStoresContext();
  const store = getStoreById(Number(storeId));
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !store) {
      navigate('/stores');
    }
  }, [store, loading, navigate]);

  if (!store) {
    return null;
  }

  const details: OverviewDetailInterface[] = [
    { title: 'ID', value: store.id },
    { title: 'Store Number', value: store.storeNumber },
    { title: 'Name', value: store.name },
    // { title: 'Address', value: store.address },
    { title: 'State / Province', value: store.state },
    { title: 'Brands', value: store.brands.map((brand) => brand.name).join(', ') },
    {
      title: 'Users',
      value: store.users.map((user) => `${user.firstName} ${user.lastName}`).join(', '),
    },
  ];

  const actions = (
    <>
      <UpdateStore store={store} text='Edit' />
      &nbsp;
      <ArchiveStore store={store} text='Archive' />
    </>
  );

  return (
    <Overview
      title={store.name}
      entityType='Store'
      customDetails={details}
      tags={store.tags}
      actions={actions}
    />
  );
};

const Store = () => (
  <UsersContextProvider>
    <StoresContextProvider>
      <BrandsContextProvider>
        <StoreComponent />
      </BrandsContextProvider>
    </StoresContextProvider>
  </UsersContextProvider>
);

export default Store;
